import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export function log(text: string) {
  return (o$: Observable<any>): Observable<any> => {
    return o$.pipe(
      tap(value => console.log(`${text}: ${value}`))
    );
  };
}